import { useRef, useState } from 'react'
import { demo } from './content.js'
import { ArrowIcon } from './ui.jsx'
import { useTurnstile } from './useTurnstile.js'

function DemoForm() {
  const [state, setState] = useState('idle')
  const [message, setMessage] = useState('We reply personally. No automated sales sequence.')
  const submittingRef = useRef(false)
  const turnstileSiteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY
  const { containerRef, reset, token } = useTurnstile(turnstileSiteKey, setMessage)

  async function submit(event) {
    event.preventDefault()
    if (submittingRef.current) return
    submittingRef.current = true
    setState('sending')
    setMessage('Sending your request…')
    const form = event.currentTarget
    const payload = { ...Object.fromEntries(new FormData(form)), turnstileToken: token }

    try {
      const response = await fetch('/api/demo', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(payload),
      })
      const result = await response.json().catch(() => ({}))
      if (!response.ok) throw new Error(result.error || 'Demo intake is not configured yet.')
      form.reset()
      reset()
      setState('sent')
      setMessage('Received. We’ll be in touch shortly.')
    } catch (error) {
      setState('error')
      setMessage(`${error.message} Email andrew@evolvea.digital instead.`)
      reset()
    } finally {
      submittingRef.current = false
    }
  }

  return (
    <form className="demo-form" onSubmit={submit}>
      <div className="form-row">
        <label><span>Work email</span><input required maxLength="254" type="email" name="email" autoComplete="email" placeholder="you@company.com" /></label>
        <label><span>Company</span><input required maxLength="160" type="text" name="company" autoComplete="organization" placeholder="Company name" /></label>
      </div>
      <label><span>{demo.prompt}</span><textarea required maxLength="2000" name="intent" rows="4" placeholder="Agent API payments, stablecoin issuance, treasury settlement…" /></label>
      <label className="honeypot" aria-hidden="true"><span>Website</span><input name="website" tabIndex="-1" autoComplete="off" /></label>
      {turnstileSiteKey ? <div className="turnstile" ref={containerRef} /> : null}
      <div className="form-submit">
        <button className="button button-blue" type="submit" disabled={state === 'sending'}>
          {state === 'sending' ? 'Sending…' : 'Request a demo'} <ArrowIcon />
        </button>
        <p role="status">{message}</p>
      </div>
    </form>
  )
}

export function Demo() {
  return (
    <section className="demo section" id="demo">
      <div className="shell demo-grid">
        <div className="demo-copy">
          <p className="eyebrow">{demo.eyebrow}</p>
          <h2>{demo.title}</h2>
          <p>{demo.summary}</p>
        </div>
        <DemoForm />
      </div>
    </section>
  )
}
